/** In-app job verification — customer shows code, mistri enters it at arrival & work start. */

export function generateJobCode() {
  return String(Math.floor(1000 + Math.random() * 9000));
}

export const JOB_STEP_ORDER = ["confirmed", "en_route", "arrived", "in_progress", "completed"] as const;

export function nextJobStep(status: string): "en_route" | "arrived" | "in_progress" | "completed" | null {
  const idx = JOB_STEP_ORDER.indexOf(status as typeof JOB_STEP_ORDER[number]);
  if (idx < 0 || idx >= JOB_STEP_ORDER.length - 1) return null;
  return JOB_STEP_ORDER[idx + 1] as "en_route" | "arrived" | "in_progress" | "completed";
}

export function stepNeedsJobCode(step: "en_route" | "arrived" | "in_progress" | "completed") {
  return step === "arrived" || step === "in_progress";
}
